<template>
  <div>
    <!--风险提示-->
    <el-dialog class="dialog-single-three" style="text-align:center;" :visible.sync="dialogVisable1" v-if="dialogVisable1" :show-close="false" :close-on-click-modal="false">
      <img src="../../assets/images/icon_fxq.png" alt="">
      <p class="riskText">根据反洗钱法律法规和基金公司要求，请您尽快完成身份证件上传并完善信息，以保证交易不受影响。</p>
      <div class="margin-t20">
        <el-button type="back" style="width:154px;" @click="$router.push({name:'myAssets'});dialogVisable1 = false;">暂不</el-button>
        <el-button type="normal" style="width:154px;" @click="$router.push({name:'perfectInformation',params:{flag:step}});dialogVisable1 = false;">立即补充</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: "Perfect",
  data () {
    return {
      dialogVisable1: false,
      step: ''
    }
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    // 用户信息
    getUserInfo () {
      this.$http.post(this.$apiPath.queryAllInfo, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        const account = res.data.data
        // if (account.accountInfo == null || account.accountInfo.profession == null || account.accountInfo.isIllegal == null || account.accountControl == null || account.accountTax == null || account.accountBenefit == null || account.accountIdcard == null) {
        //   this.dialogVisable1 = true
        //   this.step = 1
        // } else if (account.accountIdcard.address == null && account.accountAddress == null) {
        //   this.dialogVisable1 = true
        //   this.step = 1
        // }
        // 
        if (account.accountInfo != null && account.accountInfo.profession != null && account.accountInfo.isIllegal != null && account.accountControl != null && account.accountTax != null && account.accountBenefit != null && account.accountIdcard != null) {
          // 修改信息
          this.dialogVisable1 = false
          this.step = 2
        } else if (account.accountInfo != null && account.accountInfo.profession != null && account.accountInfo.isIllegal != null && account.accountControl != null && account.accountTax != null && account.accountBenefit != null && account.accountIdcard == null) {
          // 未实名认证:立即认证
          this.dialogVisable1 = true
          this.step = 1
        } else {
          // 信息未完善：立即完善
          this.dialogVisable1 = true
          if (account.accountIdcard != null) {// 上传过身份证
            this.step = 2
          } else {
            this.step = 1
          }
        }
      }).catch(err => { })
    },
  }

}
</script>

<style lang="less" scoped>
.riskText {
  font-size: 16px;
  margin-top: 20px;
}
</style>
